if (!customElements.get('add-on-widget')) {
  customElements.define(
    'add-on-widget',
    class AddOnWidget extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.initializeAddonCards()
        this.observeForNewCards()
      }

      initializeAddonCards() {
        const cards = this.querySelectorAll('.addon-widget__product-card')
        cards.forEach((card) => this.setupAddonCard(card))
      }

      observeForNewCards() {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) {
                  // element node
                  if (
                    node.classList &&
                    node.classList.contains('addon-widget__product-card')
                  ) {
                    this.setupAddonCard(node)
                  }
                  const cards =
                    node.querySelectorAll &&
                    node.querySelectorAll('.addon-widget__product-card')
                  if (cards) {
                    cards.forEach((card) => this.setupAddonCard(card))
                  }
                }
              })
            }
          })
        })

        observer.observe(this, { childList: true, subtree: true })
      }

      setupAddonCard(card) {
        if (!card) return

        const productId = card.dataset.productId
        if (!productId) return

        // get variants data from JSON script tag
        const variantScript = card.querySelector('script.addon-variants-data')
        if (!variantScript) return

        let variants = []
        try {
          variants = JSON.parse(variantScript.textContent)
        } catch (e) {
          console.error('Error parsing addon variants:', e)
          return
        }

        // attach listeners to ALL select elements in this card
        const selects = card.querySelectorAll('select.addon-variant-select')
        const updateVariant = () =>
          this.updateAddonVariantId(card, variants, selects)

        selects.forEach((select) => {
          select.addEventListener('change', updateVariant)
        })

        // also watch for checkbox changes to enable/disable quantity
        const checkbox = card.querySelector('.addon-item__checkbox')
        if (checkbox) {
          checkbox.addEventListener('change', () => {
            const qty = card.querySelector('.addon-item__quantity')
            if (qty) {
              qty.disabled = !checkbox.checked
            }
          })
        }

        // initialize with correct variant on load
        updateVariant()
      }

      updateAddonVariantId(card, variants, selects) {
        // collect all selected option values from THIS card only
        const selectedValues = []
        selects.forEach((select) => {
          if (select.value) {
            selectedValues.push(select.value)
          }
        })

        // find variant that matches ALL selected option values
        let matchedVariant = null

        if (selectedValues.length === 0) {
          // if no selections, use first variant
          matchedVariant = variants[0]
        } else if (selectedValues.length === 1) {
          // for single option: find variant where one of its titles matches
          matchedVariant = variants.find((v) => {
            return (
              selectedValues[0].includes(v.title) ||
              v.title.includes(selectedValues[0])
            )
          })
        } else {
          // for multiple options: all must match in the variant title
          // e.g., "Red / Small" should match variant with title "Red / Small"
          matchedVariant = variants.find((v) => {
            return selectedValues.every((val) => {
              return v.title.includes(val)
            })
          })
        }

        // if still no match, find by exact title combination
        if (!matchedVariant) {
          const expectedTitle = selectedValues.join(' / ')
          matchedVariant = variants.find((v) => {
            return v.title === expectedTitle
          })
        }

        // fallback: just use first available
        if (!matchedVariant && variants.length > 0) {
          matchedVariant = variants[0]
        }

        if (matchedVariant) {
          const checkbox = card.querySelector('.addon-item__checkbox')
          if (checkbox) {
            checkbox.dataset.addonId = matchedVariant.id
          }

          // Update image if the variant has one
          const variantImageSrc =
            matchedVariant.featured_image?.src ||
            matchedVariant.featured_image ||
            matchedVariant.image?.src ||
            matchedVariant.image
          const variantImageAlt =
            matchedVariant.featured_image?.alt ||
            matchedVariant.image?.alt ||
            ''

          if (variantImageSrc) {
            const imageElements = card.querySelectorAll(
              '.product-card__media img',
            )
            const sourceElements = card.querySelectorAll(
              '.product-card__media source',
            )

            imageElements.forEach((img) => {
              img.src = variantImageSrc
              img.srcset = variantImageSrc
              if (variantImageAlt) {
                img.alt = variantImageAlt
              }
            })

            sourceElements.forEach((source) => {
              source.srcset = variantImageSrc
            })
          }

          // Update prices
          const salePriceEl = card.querySelector('.price-item--sale')
          const regularPriceContainer = card.querySelector(
            '.price-item--regular',
          )?.parentElement

          if (salePriceEl) {
            if (
              typeof Shopify !== 'undefined' &&
              typeof Shopify.formatMoney === 'function'
            ) {
              salePriceEl.textContent = Shopify.formatMoney(
                matchedVariant.price,
              )
            } else {
              salePriceEl.textContent =
                '$' + (matchedVariant.price / 100).toFixed(2)
            }
          }

          if (regularPriceContainer) {
            const regularPriceEl = regularPriceContainer.querySelector(
              '.price-item--regular',
            )
            if (
              matchedVariant.compare_at_price &&
              matchedVariant.compare_at_price > matchedVariant.price
            ) {
              if (
                typeof Shopify !== 'undefined' &&
                typeof Shopify.formatMoney === 'function'
              ) {
                regularPriceEl.textContent = Shopify.formatMoney(
                  matchedVariant.compare_at_price,
                )
              } else {
                regularPriceEl.textContent =
                  '$' + (matchedVariant.compare_at_price / 100).toFixed(2)
              }
              regularPriceContainer.style.display = ''
            } else {
              regularPriceContainer.style.display = 'none'
            }
          }
        }
      }
    },
  )
}
